/* Foucault · Movimiento y detalle (v5.0, 24-10-2026). Estilos en assets/foucault-movimiento.css */
(function () {
  var quieto = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* A. Agregar al carro: detecta /cart/add correcto y anima el ícono.
        Cubre el botón normal, el botón fijo de celular y cualquier compra rápida. */
  function darCuerda() {
    var ic = document.getElementById('cart-icon-bubble');
    if (!ic || quieto) return;
    ic.classList.remove('fc-cuerda');
    void ic.offsetWidth;
    ic.classList.add('fc-cuerda');
    setTimeout(function () { ic.classList.remove('fc-cuerda'); }, 1000);
  }
  if (window.fetch && !window.fetch.fcCuerda) {
    var fetchOriginal = window.fetch;
    var envuelto = function (entrada) {
      var promesa = fetchOriginal.apply(this, arguments);
      try {
        var url = typeof entrada === 'string' ? entrada : (entrada && entrada.url) || '';
        if (/\/cart\/add/.test(url)) {
          promesa.then(function (r) { if (r && r.ok) setTimeout(darCuerda, 350); }).catch(function () {});
        }
      } catch (e) {}
      return promesa;
    };
    envuelto.fcCuerda = true;
    window.fetch = envuelto;
  }

  function iniciar() {
    /* B. Separadores de latón entre secciones consecutivas con el mismo fondo claro. */
    var secciones = [].slice.call(document.querySelectorAll('main .shopify-section'));
    var fondo = function (s) {
      var f = s.firstElementChild;
      return f ? getComputedStyle(f).backgroundColor : '';
    };
    for (var i = 1; i < secciones.length; i++) {
      var a = secciones[i - 1], b = secciones[i];
      if (!a.offsetHeight || !b.offsetHeight) continue;
      var fa = fondo(a), fb = fondo(b);
      if (fa && fa === fb && fa !== 'rgba(0, 0, 0, 0)' && /^rgb\((2[0-9]{2}), (2[0-9]{2}), (2[0-9]{2})\)$/.test(fb)) {
        b.classList.add('fc-divisor');
      }
    }

    if (quieto || !('IntersectionObserver' in window)) return;

    /* C. Aparición escalonada en secciones Foucault que no la tenían. */
    var grupos = [
      '.fc-trust__item',
      '.fc .fc-head',
      '.fc-social__card',
      '.fc-split__body > *',
      '.fc-guide',
      '.fc-faq__list > details',
      '.fc-news__intro',
      '.fc-news > form'
    ];
    var vh = window.innerHeight;
    var marcados = [];
    grupos.forEach(function (sel) {
      var porPadre = new Map();
      document.querySelectorAll(sel).forEach(function (el) {
        if (el.closest('[data-fc-reveal]') || el.hasAttribute('data-fc-mv')) return;
        if (el.tagName === 'SCRIPT' || el.tagName === 'STYLE') return;
        if (el.getBoundingClientRect().top < vh * 0.92) return; /* ya visible al cargar: no se toca */
        var p = el.parentElement;
        var n = porPadre.get(p) || 0;
        porPadre.set(p, n + 1);
        el.setAttribute('data-fc-mv', '');
        el.style.transitionDelay = Math.min(n, 5) * 80 + 'ms';
        marcados.push(el);
      });
    });

    var divisores = [].slice.call(document.querySelectorAll('.shopify-section.fc-divisor')).filter(function (s) {
      return s.getBoundingClientRect().top >= vh * 0.92;
    });
    document.querySelectorAll('.shopify-section.fc-divisor').forEach(function (s) {
      if (divisores.indexOf(s) === -1) s.classList.add('is-in');
    });

    if (!marcados.length && !divisores.length) return;
    document.documentElement.classList.add('fc-mv-on');

    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('is-in');
          io.unobserve(en.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    marcados.concat(divisores).forEach(function (el) { io.observe(el); });

    /* Red de seguridad: si algo no se observó bien, a los 6 s queda todo visible. */
    setTimeout(function () {
      marcados.concat(divisores).forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight) el.classList.add('is-in');
      });
    }, 6000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();